import { defineStore } from 'pinia';
import initialState from './state.js';
import actions from './actions.js';
import getters from './getters.js';

export const useUserStore = defineStore('users', {
    state: () => initialState,
    getters,
    actions,
});
